import React from 'react';
import DriversTable from './DriversTable';

export default function SuspendedDrivers() {
  return <DriversTable title="Suspended drivers" orderByChild="status" equalTo="suspended" />;
}
